""// CategoryContent.js
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { API } from "../../API";
import "./CategoryContent.css";
import NavBar from "../Navbar";
import { Helmet } from "react-helmet-async";

const SkeletonCard = () => (
    <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
        <div className="card shadow-sm h-100 placeholder-glow">
            <div className="placeholder w-100" style={{ height: '200px', backgroundColor: '#e0e0e0' }}></div>
            <div className="card-body">
                <div className="placeholder col-8 mb-2" style={{ height: '1.2rem' }}></div>
                <div className="placeholder col-6" style={{ height: '1rem' }}></div>
            </div>
        </div>
    </div>
);
const CategoryContent = () => {
    const { channel_Name } = useParams();
    const [category, setCategory] = useState({});
    const [contents, setContents] = useState([]);
    const [loading, setLoading] = useState(false);
    const [subchannels, setSubchannels] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    // 12 fills the four-across grid exactly (9 left a gap).
    const itemsPerPage = 12;

    useEffect(() => {
        const fetchCategoryContent = async () => {
            try {
                setLoading(true);
                const { data } = await axios.get(`${API}/api/lesson/channel/${channel_Name}`);
                console.log('huuu', data)
                setCategory(data?.mainChannel || {});
                setSubchannels(data?.subchannels || []);
                // This page shows the Network Channel's OWN videos only. The API
                // also sends its Channels' videos; those stay on each Channel's
                // own page, reached from the Channels section below.
                const ownVideos = (data?.data || []).filter(
                    (video) => video?.channelType === "Channels"
                );
                setContents(ownVideos);
                setTotalPages(Math.ceil(ownVideos.length / itemsPerPage));
                setLoading(false);
            } catch (error) {
                console.error("Error fetching channel details:", error);
                setLoading(false);
            }
        };

        fetchCategoryContent();
    }, [channel_Name]);

    const getPaginatedData = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        return contents?.slice(startIndex, startIndex + itemsPerPage);
    };

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    const generateSlug = (title, id) => `${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-${id}`;
    const generateSubchannelSlug = (name) => `${name?.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;
    const generateChannellSlug = (name) => `${name?.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;

    // const slugify = (text = "") => {
    //     return `${text.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`
    // };

    return (
        <>
            <Helmet>
                <title>
                    {category?.name ? `${category?.name} - Network Channel | Watch Now` : "Explore Network Channel - OTT Network Channel"}
                </title>
                <meta
                    name="description"
                    content={`Explore the best ${category?.name?.toLowerCase() || "Network Channels"} on our Network Channel, featuring exclusive movies, TV shows, and more.`}
                />
            </Helmet>

            <NavBar categoryLogo={category?.logo?.url} categoryId={`/net_channel/${generateSubchannelSlug(channel_Name)}`} />

            <div className="container py-4">
                {loading ? (
                    <>
                        <div className="row">
                            {Array.from({ length: 8 }).map((_, i) => (
                                <SkeletonCard key={i} />
                            ))}
                        </div>
                    </>
                ) : (
                    <>
                        {category?.banner?.url && (
                            <div className="category-banner mb-4">
                                <img src={category.banner.url} alt={category.name || "Channel"} className="img-fluid w-100 rounded" />
                            </div>
                        )}

                        {/* FIRST: the Network Channel's own videos. Hidden when it has none,
                            so its Channels come first; shown with its "no videos" message only
                            when there are no Channels either. */}
                        {(contents?.length > 0 || !(subchannels?.length > 0)) && (
                            <>
                        <div className="mb-5">
                            <h4 className="mb-3">View Videos</h4>
                            <div className="row">
                                {getPaginatedData()?.length > 0 ? (
                                    getPaginatedData().map((content) => (
                                        <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4" key={content._id}>
                                            <Link to={


                                                // `/view/${generateSlug(content.title, content._id)}`


                                                content?.channelType === "Subchannels"
                                                    ? `/${generateChannellSlug(content?.channel?.parentChannel?.name)}/channel/${generateChannellSlug(content?.channel?.name)}/${generateSlug(content.title, content._id)}`
                                                    : `/${generateChannellSlug(content?.channel?.name)}/${generateSlug(content.title, content._id)}`


                                            } className="text-decoration-none">
                                                <div className="card shadow-sm h-100">
                                                    <img src={content.thumbnail} alt={content.title} className="card-img-top" style={{ height: '200px', objectFit: 'cover' }} />
                                                    <div className="card-body">
                                                        <h5 className="card-title text-center text-dark">{content.title}</h5>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    ))
                                ) : (
                                    <div className="col-12 text-center text-muted py-5">
                                        <h5>No videos uploaded related to this channel.</h5>
                                    </div>
                                )}
                            </div>
                        </div>

                        {
                            contents?.length > itemsPerPage && (
                                <nav>
                                    <ul className="pagination justify-content-center">
                                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                            <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
                                        </li>
                                        {Array.from({ length: totalPages }, (_, i) => (
                                            <li className={`page-item ${currentPage === i + 1 ? "active" : ""}`} key={i}>
                                                <button className="page-link" onClick={() => handlePageChange(i + 1)}>{i + 1}</button>
                                            </li>
                                        ))}
                                        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                            <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>Next</button>
                                        </li>
                                    </ul>
                                </nav>
                            )
                        }
                            </>
                        )}

                        {/* THEN: its Channels. */}
                        {subchannels?.length > 0 && (
                            <div className="mb-5">
                                <h4 className="mb-3">Explore Channels</h4>
                                <div className="row">
                                    {subchannels.map((sub) => (
                                        <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4" key={sub._id}>
                                            <Link
                                                to={
                                                    `/${channel_Name.replace(/\s+/g, "-")}/channel/${generateSubchannelSlug(sub.name)}`

                                                    // sub?.channelType === "Subchannels"
                                                    //     ? `/${generateChannellSlug(sub?.channel?.parentChannel?.name)}/${generateChannellSlug(sub?.channel?.name)}/${generateSubchannelSlug(sub.name)}`
                                                    //     : `/${generateChannellSlug(sub?.channel?.name)}/${generateSubchannelSlug(sub.name)}`
                                                }

                                                className="text-decoration-none"
                                            >
                                                <div className="card shadow-sm h-100">
                                                    <img src={sub.thumbnail?.url} alt={sub.name} className="card-img-top" style={{ height: '180px', objectFit: 'cover' }} />
                                                    <div className="card-body">
                                                        <h5 className="card-title text-center text-dark">{sub.name}</h5>
                                                    </div>
                                                </div>
                                            </Link >
                                        </div >
                                    ))}
                                </div >
                            </div >
                        )}
                    </>
                )}
            </div >
        </>
    );
};

export default CategoryContent;
